import userPool from '../userPool';

window.userPool = userPool;

export const HANDLE_NEW_CREDENTIALS = "HANDLE_NEW_CREDENTIALS";
export const handleNewCredentials = (token) => {
  return {
    type: HANDLE_NEW_CREDENTIALS,
    token: token
  }
}

export const HANDLE_USER_SESSION = "HANDLE_USER_SESSION";
export const handleNewSession = (name, email, organization, token, tos) => {
  return {
    type: HANDLE_USER_SESSION,
    name: name,
    email: email,
    organization: organization,
    token: token,
    tos
  }
}

export const SIGN_OUT = "SIGN_OUT";
export const signOut = () => {
  userPool.signOut();
  return {
    type: SIGN_OUT
  }
}

export const NEW_USER_ATTRIBUTES = "NEW_USER_ATTRIBUTES";
export const newUserAttributes = (attrs) => {
  return {
    type: NEW_USER_ATTRIBUTES,
    attributes: attrs.reduce((memo, attr) => {
      memo[attr.getName()] = attr.getValue();
      return memo
    }, {})
  }
}

export const AUTH_ERROR = "AUTH_ERROR";
export const authError = (err) => {
  return {
    type: AUTH_ERROR,
    error: err.toString()
  }
}

export const SIGN_IN = "SIGN_IN";
export const SIGNING_IN = "SIGNING_IN";
export const signIn = (email, password, callback) => {
  return (dispatch, getStore) => {
    dispatch({type: SIGNING_IN});
    userPool.authenticate(email, password, (err, creds, a) => {
      if (err) {
        dispatch(authError(err))
      } else {
        userPool.getUserAttributes((err, result) => {
          if (err) {
            throw err
          } else {
            let attrs = result.reduce((memo, r) => { memo[r.Name] = r.Value; return memo }, {});
            dispatch(handleNewSession(attrs.name, attrs.email, attrs["custom:organization"], creds.idToken.jwtToken, attrs["custom:tos"]))
            if (callback) {
              callback(null);
            }
          }
        });
      }
    },
    // new password required callback
    (userAttributes, requiredAttributes) => {
      dispatch(newUserAttributes(userAttributes));
      dispatch({
        type: NEW_PASSWORD_REQUIRED
      })
    })
  }
}

export const NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED";

export const completeNewPasswordChallenge = (password) => {
  return (dispatch, getStore) => {
    userPool.completeNewPasswordChallenge(password, (err, result) => {
      dispatch(handleNewCredentials(result.idToken.jwtToken))
    });
  }
}

export const REGISTERING = 'REGISTERING';

export const register = (attrs, callback) => {
  return (dispatch, getStore) => {
    dispatch({
      type: REGISTERING
    })
    userPool.registerUser(attrs, (err, result) => {
      if (err) {
        dispatch(authError(err))
      } else {
        // TODO: re-enable this once enabling users by default
        // signIn(attrs.email, attrs.password, callback)(dispatch, getStore);
        dispatch(signOut());
        alert("Thank you for registering. You will receive an email with a link to confirm your registration. Once confirmed, you may log in.");
        callback(null)
      }
    });
  }
}

export const resetAuthErrors = () => {
  return {
    type: AUTH_ERROR,
    error: null
  }
}

export const FORGOT_PASSWORD_CODE_SENT = 'FORGOT_PASSWORD_CODE_SENT';
export const PASSWORD_RESET = 'PASSWORD_RESET';

export const forgotPassword = (email) => {
  return (dispatch, getState) => {
    userPool.forgotPassword(email, (err) => {
      if (err) {
        dispatch(authError(err));
      } else {
        dispatch({
          type: FORGOT_PASSWORD_CODE_SENT
        })
      }
    });
  }
}

export const resetPassword = (code, password) => {
  return (dispatch, getState) => {
    userPool.confirmPassword(code, password, (err) => {
      if (err) {
        dispatch(authError(err))
      } else {
        alert("Your password has been reset. You can now use this new password to login.")
        dispatch({
          type: PASSWORD_RESET
        });
      }
    });
  }
}

export const ACCEPT_TOS = 'ACCEPT_TOS';
export const acceptTos = () => {
  return (dispatch, getState) => {
    dispatch({type: ACCEPT_TOS});
    window.cognitoUser.updateAttributes([{Name: 'custom:tos', Value: 'signed'}], () => {})
  }
}
